<template>
  <base-switch-case :value="typeInput">
    <template #color>
      <field-group
        class="my-1"
        inline
        onlyColor
        :label="label"
        v-model="currentValue"
        type-input="field-color-picker"
        v-bind="option"
      ></field-group>
    </template>
    <template #length>
      <field-group
        class="my-1"
        inline
        onlyColor
        :label="label"
        v-model="currentValue"
        type="number"
        min="0"
        step="0.1"
        suffix="px"
        v-bind="option"
      ></field-group>
    </template>
    <template #percentage>
      <field-group class="my-1" inline :label="label">
        <template #input>
          <rulePercentage
            v-model="currentValue"
            v-bind="option"
          ></rulePercentage>
        </template>
      </field-group>
    </template>
    <template #icon>
      <rule-icon
        class="my-1"
        inline
        :label="label"
        v-model="currentValue"
        v-bind="option"
        :type="gettypeByInputType(typeInput)"
      >
      </rule-icon>
    </template>
    <template #font>
      <rule-font
        class="my-1"
        inline
        :label="label"
        v-model="currentValue"
        v-bind="option"
        :type="gettypeByInputType(typeInput)"
      >
      </rule-font>
    </template>
    <template #default>
      <field-group
        class="my-1"
        inline
        :label="label"
        v-bind="option"
        v-model="currentValue"
        :type-input="gettypeByInputType(typeInput)"
      >
      </field-group>
    </template>
  </base-switch-case>
</template>

<script>
import asyncComponent from '@components/async'
export default {
  components: {
    ruleIcon: () => asyncComponent(import('./rule-icon.vue')),
    ruleFont: () => asyncComponent(import('./rule-font.vue')),
    rulePercentage: () => asyncComponent(import('./rule-percentage.vue')),
  },
  props: {
    value: {},
    typeInput: {},
    label: String,
    option: { type: Object, default: () => ({}) },
  },
  data: () => ({}),
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    gettypeByInputType(type) {
      return inputType[type] || type
    },
  },
}
let inputType = {
  string: 'v-text-field',
  integer: 'number',
}
</script>

<style></style>
